export const DISCLAIMERS = [
  {
    id: 'share-links',
    message: 'delete_public_dashboard.share_links',
  },
  {
    id: 'access-keys',
    message: 'delete_public_dashboard.access_keys',
  },
  {
    id: 'embedded-html',
    message: 'delete_public_dashboard.embedded_html',
  },
];
